const BASE_URL = 'favorites'

export default {
  ADD_FAVORITE: `/${BASE_URL}`,
  REMOVE_FAVORITE: `/${BASE_URL}`,
}
